export const excludeRuChars = (str: string) => {
  return str.replace(/[А-аЯ-я]/g, '');
};
